/* Timbrica — /wildfire-map ("карта пожаров" / active fire hotspots).
 *
 * Satellite active-fire detections (NASA FIRMS MODIS, last ~24h) drawn on a
 * canvas overlay over the shared basemap (js/map-tiles.js). Each detection is a crisp dot
 * coloured by Fire Radiative Power with a soft underglow so dense regions read
 * as "hot" without washing out to white. Click a hotspot to see its FRP,
 * brightness, when it was seen, and — reverse-geocoded server-side — the
 * nearest settlement, plus a one-tap link to open the exact spot in a map.
 *
 * Honest framing: thermal DETECTIONS refreshed within hours — not "live", not
 * fire perimeters, not an emergency source. Data + reverse-geocode both come
 * through same-origin /api/wildfire/* proxies so RU users behind CDN blocks
 * still get everything.
 */
(function () {
  'use strict';
  var C = window.WILDFIRE_CFG || {};
  var T = C.t || {}, API = C.api || {};
  var LOC = C.locale || (window.__LOCALE || 'en');
  var tr = function (k) { return T[k] != null && T[k] !== '' ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };

  /* Две палитры очагов, а не одна. На тёмной подложке самый мощный очаг —
     БЕЛО-жёлтый (#fff3c4): так рисуют жар. На светлой это ровно наоборот —
     бело-жёлтое на #fafaf8 исчезает, и «самый сильный пожар» становится
     невидимым первым. Поэтому светлая пятёрка идёт ОТ тёмного янтаря К
     почти чёрному красному: чем горячее, тем темнее. Контраст к светлой
     подложке держит MapBasemapBrightnessTest (>3). */
  var RAMP = {
    dark:  { c: ['#ffd24d', '#ff7e29', '#ff3b1f', '#fff3c4'], halo: 0.18, ink: '#fff',     blend: 'lighter' },
    light: { c: ['#a87800', '#d1590a', '#c0170a', '#8c0f06'], halo: 0.22, ink: '#0b1020', blend: 'multiply' }
  };
  var skin = RAMP.dark;
  function frpColor(f) { return f >= 200 ? skin.c[3] : f >= 80 ? skin.c[2] : f >= 25 ? skin.c[1] : skin.c[0]; }
  function frpRadius(f) { return Math.max(2, Math.min(7, 2 + Math.log(1 + f) * 0.8)); }
  function nfmt(n) { try { return Number(n).toLocaleString(LOC); } catch (e) { return '' + n; } }
  function frpFmt(f) { try { return Number(f).toLocaleString(LOC, { maximumFractionDigits: 1 }); } catch (e) { return '' + f; } }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function fmtAgo(tsSec) {
    if (!tsSec) return '';
    var s = Date.now() / 1000 - tsSec;
    if (s < 0) s = 0;
    if (s < 90) return tr('just_now');
    if (s < 3600) return Math.round(s / 60) + ' ' + tr('ago_min');
    if (s < 86400) return Math.round(s / 3600) + ' ' + tr('ago_hr');
    return Math.round(s / 86400) + ' ' + tr('ago_day');
  }
  function haversine(aLat, aLon, bLat, bLon) {
    var r = Math.PI / 180, dLat = (bLat - aLat) * r, dLon = (bLon - aLon) * r;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(aLat * r) * Math.cos(bLat * r) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 6371 * 2 * Math.asin(Math.min(1, Math.sqrt(h)));
  }
  function mapsUrl(lat, lon) {
    if (LOC === 'ru') { return 'https://yandex.ru/maps/?ll=' + lon + ',' + lat + '&z=11&pt=' + lon + ',' + lat + ',pm2rdm'; }
    return 'https://www.google.com/maps?q=' + lat + ',' + lon + '&z=11';
  }

  var map = null, cv = null, fires = [], sel = null, userLL = null, userDot = null;
  var placeCache = {}; // "lat,lon" -> {arrow,name,dist}|null

  function initMap() {
    if (!window.L || !$('wfMap')) return;
    var tile = C.tile || {};
    map = L.map('wfMap', {
      center: [C.home ? C.home.lat : 10, C.home ? C.home.lon : 30],
      zoom: C.home ? C.home.z : 2,
      minZoom: 2, maxZoom: 12, worldCopyJump: true
    });
    /* Подложка через общий примитив: второй адрес (наш прокси <-> прямой CDN)
       и строка человеку, если не ответил ни один.
       Раньше отказ считался и уходил В ТЕЛЕМЕТРИЮ на 8-й плитке — то есть мы
       узнавали о чёрной карте, а пользователь нет. Запись в статистике не
       заменяет слова на экране. */
    if (window.__mapTiles) {
        window.__mapTiles.base(L, map, null, {
            slug: 'wildfire-map', credit: tr('map_attr'), opts: { maxZoom: 19 }, text: tile.offline,
            styles: tile.styles, labels: tile.labels,
            // Яркость подложки тянет за собой палитру очагов и стекло панелей.
            onStyle: function (mode) {
                skin = RAMP[mode] || RAMP.dark;
                var st = document.getElementById('wfStage');
                if (st) st.setAttribute('data-basemap', mode);
                if (typeof redraw === 'function') redraw();
            }
        });
    } else if (window.__basemapFallback) {
        window.__basemapFallback(L, map, tr('map_attr'));
    }
    cv = document.createElement('canvas'); cv.className = 'wf-canvas'; cv.style.pointerEvents = 'none';
    map.getPanes().overlayPane.appendChild(cv);
    map.on('move zoom resize viewreset moveend zoomend', redraw);
    map.on('click', onClick);
  }

  // Zoom-aware scale so hotspots grow as you zoom in (easier to see + tap, and
  // dense clusters spatially separate instead of staying a single blob).
  function zoomScale() {
    var z = map ? map.getZoom() : 3;
    return z <= 3 ? 0.9 : z <= 5 ? 1.1 : z <= 7 ? 1.35 : z <= 9 ? 1.7 : 2.2;
  }

  function redraw() {
    if (!map || !cv) return;
    var size = map.getSize(), dpr = window.devicePixelRatio || 1;
    cv.width = size.x * dpr; cv.height = size.y * dpr;
    cv.style.width = size.x + 'px'; cv.style.height = size.y + 'px';
    L.DomUtil.setPosition(cv, map.containerPointToLayerPoint([0, 0]));
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, size.x, size.y);
    var zf = zoomScale(), z = map.getZoom();
    var pts = [], i, f, pt;

    // Pass 1 — soft additive underglow (warmth/density cue), kept low so big
    // clusters glow rather than blow out to pure white.
    /* ⚠️ 'lighter' — приём ТЁМНОГО фона: сложение цветов даёт свечение. На
       белой подложке то же сложение упирается в белый, и густые скопления
       очагов превращаются в БЕЛЫЕ пятна — данные стираются ровно там, где
       их больше всего (поймано скриншотом 23.08, доля потерянных пикселей
       31.6% против 16.8 на тёмной). Двойник для светлого фона —
       'multiply': он затемняет ровно так же, как 'lighter' высветляет. */
    ctx.globalCompositeOperation = skin.blend;
    for (i = 0; i < fires.length; i++) {
      f = fires[i]; pt = map.latLngToContainerPoint([f[0], f[1]]);
      if (pt.x < -12 || pt.y < -12 || pt.x > size.x + 12 || pt.y > size.y + 12) continue;
      var r = frpRadius(f[2]) * zf;
      pts.push([pt.x, pt.y, r, f]);
      ctx.beginPath(); ctx.arc(pt.x, pt.y, r * 1.9, 0, 6.2832);
      ctx.fillStyle = frpColor(f[2]); ctx.globalAlpha = skin.halo; ctx.fill();
    }

    // Pass 2 — crisp solid cores (source-over) so every detection reads as a
    // distinct point; a thin dark rim adds contrast once zoomed in.
    ctx.globalCompositeOperation = 'source-over';
    var rim = z >= 6;
    for (i = 0; i < pts.length; i++) {
      var p = pts[i];
      ctx.beginPath(); ctx.arc(p[0], p[1], p[2], 0, 6.2832);
      ctx.fillStyle = frpColor(p[3][2]); ctx.globalAlpha = 0.92; ctx.fill();
      if (rim) { ctx.globalAlpha = 0.5; ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(30,10,0,.7)'; ctx.stroke(); }
    }

    // Selection ring on top.
    if (sel) {
      var sp = map.latLngToContainerPoint([sel[0], sel[1]]);
      ctx.beginPath(); ctx.arc(sp.x, sp.y, frpRadius(sel[2]) * zf + 6, 0, 6.2832);
      ctx.globalAlpha = 1; ctx.lineWidth = 2; ctx.strokeStyle = skin.ink; ctx.stroke();
    }
    ctx.globalAlpha = 1;
  }

  function onClick(ev) {
    if (!fires.length) return;
    var c = ev.containerPoint, best = null, bd = 1e9, zf = zoomScale();
    for (var i = 0; i < fires.length; i++) {
      var f = fires[i], pt = map.latLngToContainerPoint([f[0], f[1]]);
      var d = Math.hypot(pt.x - c.x, pt.y - c.y);
      var hit = Math.max(14, frpRadius(f[2]) * zf + 7);
      if (d < bd && d <= hit) { bd = d; best = f; }
    }
    if (best) selectFire(best);
  }

  /* Где очаг — общий модуль GeoCity (public/js/geo-city.js): ближайший город
     с именем на языке страницы, включая посёлки тайги из русского дополнения. */
  function placeLine(f) {
    var key = f[0].toFixed(3) + ',' + f[1].toFixed(3);
    if (placeCache[key] !== undefined) return renderPlace(placeCache[key]);
    if (!window.GeoCity) return renderPlace(null);
    GeoCity.lookup(f[0], f[1], { mode: 'near', far: true }).then(function (it) {
      var v = GeoCity.parts(it, { distance: true });
      // Сеть моргнула (it === null) — не запоминаем: следующий клик спросит снова.
      if (it) placeCache[key] = v;
      if (sel === f) { var el = $('wfPlace'); if (el) el.innerHTML = renderPlace(v); }
    });
    return '<span class="wf-place-load">' + esc(tr('looking_up')) + '</span>';
  }
  function renderPlace(v) {
    if (!v || !v.name) return '<span class="wf-place-na">—</span>';
    var s = (v.arrow ? '<span class="wf-arrow">' + v.arrow + '</span> ' : '') + esc(v.name);
    if (v.dist) s += ' · ' + esc(v.dist);
    return s;
  }

  function selectFire(f) {
    sel = f; redraw();
    var card = $('wfCard'); if (!card) return;
    var ago = fmtAgo(f[5]);
    var dn = f[4] ? tr('day') : tr('night');
    var timeVal = ago ? (ago + ' · ' + dn) : dn;
    card.innerHTML =
      '<button class="wf-x" id="wfX" aria-label="' + esc(tr('close') || '×') + '">&times;</button>' +
      '<div class="wf-frp" style="color:' + frpColor(f[2]) + '">' + frpFmt(f[2]) + ' <small>' + esc(tr('mw')) + '</small></div>' +
      '<div class="wf-sub">' + esc(tr('frp')) + '</div>' +
      '<div class="wf-row"><span>' + esc(tr('place')) + '</span><b id="wfPlace">' + placeLine(f) + '</b></div>' +
      '<div class="wf-row"><span>' + esc(tr('brightness')) + '</span><b>' + nfmt(f[3]) + ' ' + esc(tr('k')) + '</b></div>' +
      '<div class="wf-row"><span>' + esc(tr('time')) + '</span><b>' + esc(timeVal) + '</b></div>' +
      '<div class="wf-row"><span>' + esc(tr('coords')) + '</span><b>' + f[0].toFixed(3) + ', ' + f[1].toFixed(3) + '</b></div>' +
      '<a class="wf-maplink" href="' + mapsUrl(f[0], f[1]) + '" target="_blank" rel="noopener nofollow">' + esc(tr('open_map')) + ' →</a>' +
      '<div class="wf-detect">' + esc(tr('detection_note')) + '</div>';
    card.style.display = 'block';
    var x = $('wfX'); if (x) x.onclick = function () { card.style.display = 'none'; sel = null; redraw(); };
    var ml = card.querySelector('.wf-maplink'); if (ml) ml.onclick = function () { ae('feature_use', { slug: 'wildfire-map', feature: 'open_map' }); };
    ae('feature_use', { slug: 'wildfire-map', feature: 'select' });
  }

  function renderStats(d) {
    if (!fires.length) return;
    var big = fires[0]; // server sorts by FRP desc
    var total = (d && d.total) || fires.length;
    var s = $('wfStats'); if (!s) return; s.style.display = 'flex';
    s.innerHTML =
      '<button class="wf-stat" id="wfBig">' + esc(tr('biggest')) + ' <b>' + frpFmt(big[2]) + ' ' + esc(tr('mw')) + '</b></button>' +
      '<span class="wf-stat">' + esc(tr('total_hotspots')) + ' <b>' + nfmt(total) + '</b></span>';
    var b = $('wfBig'); if (b) b.onclick = function () { map.flyTo([big[0], big[1]], 8); selectFire(big); ae('feature_use', { slug: 'wildfire-map', feature: 'biggest' }); };
  }

  function load() {
    fetch(API.recent).then(function (r) { return r.json(); }).then(function (d) {
      fires = (d && d.fires) || [];
      redraw(); renderStats(d);
      var ld = $('wfLoading'); if (ld) ld.classList.add('hidden');
      var dot = $('wfDot'); if (dot) dot.classList.toggle('stale', !!(d && d.stale));
      var total = (d && d.total) || fires.length;
      var upd = $('wfUpd'); if (upd) upd.textContent = tr('hotspots_n').replace(':n', nfmt(total));
    }).catch(function () { ae('tool_error', { slug: 'wildfire-map', where: 'recent' }); });
  }

  function locate() {
    // Reported this as a DENIAL, which it is not — the API was never there.
    if (!navigator.geolocation) { if (window.__geo) __geo.notify('no_api'); return; }
    // Карты может не быть вовсе: initMap() молча выходит, если Leaflet не
    // доехал. Кнопка при этом оставалась живой, и клик уводил в
    // `null.flyTo` (Sentry GT). Отказ должен быть СКАЗАН, а не брошен.
    if (!map) { mapUnavailable(); return; }
    var b = $('wfLocate'); if (b) b.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) {
      // Между запросом и ответом проходят секунды: за это время вкладку могли
      // увести, а карту — снести. Позиция пришла к объекту, которого уже нет.
      if (!map) { if (b) b.disabled = false; mapUnavailable(); return; }
      userLL = [pos.coords.latitude, pos.coords.longitude];
      map.flyTo(userLL, 7);
      if (userDot) { try { map.removeLayer(userDot); } catch (e) {} }
      userDot = L.circleMarker(userLL, { radius: 6, color: '#7aa7ff', weight: 2, fillColor: '#7aa7ff', fillOpacity: .6 }).addTo(map);
      reportNearestFire();
      ae('feature_use', { slug: 'wildfire-map', feature: 'locate' });
      if (b) b.disabled = false;
    }, function () { if (b) b.disabled = false; try { window.__toast && window.__toast(tr('geo_denied') || 'Location denied', 'warning'); } catch (e) {} },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
  }

  // After locating, tell the user how close the nearest detection is — the core
  // "is there a fire near me?" answer.
  function reportNearestFire() {
    if (!userLL || !fires.length) return;
    var best = null, bd = Infinity;
    for (var i = 0; i < fires.length; i++) {
      var d = haversine(userLL[0], userLL[1], fires[i][0], fires[i][1]);
      if (d < bd) { bd = d; best = fires[i]; }
    }
    try {
      if (best && bd <= 200) { window.__toast && window.__toast(tr('nearest_fire').replace(':d', nfmt(Math.round(bd))), 'info'); }
      else { window.__toast && window.__toast(tr('no_fire_near'), 'success'); }
    } catch (e) {}
  }

  // Один ответ на «карты нет»: сказать человеку и погасить то, что без неё
  // не работает. Молчаливая живая кнопка — это и есть дефект, а не её отказ.
  function mapUnavailable() {
    try {
      var msg = tr('map_unavailable') || tr('geo_denied');
      if (window.__toast && msg) window.__toast(msg, 'warning');
    } catch (e) {}
    var b = $('wfLocate'); if (b) b.disabled = true;
    ae('tool_error', { slug: 'wildfire-map', error_type: 'map_unavailable' });
  }

  function boot() {
    try { window.Timbrica3D && window.Timbrica3D.init && window.Timbrica3D.init('wildfire-map'); } catch (e) {}
    initMap(); load();
    var lb = $('wfLocate'); if (lb) lb.addEventListener('click', locate);
    // Leaflet может приехать ПОЗЖЕ: свой адрес сорвался, и запасная копия
    // (повтор на своём хосте, затем зеркало) добирается секундами позже —
    // замерено, лестница отрабатывает целиком. Раньше initMap() к этому
    // моменту уже вышел, и тул оставался без карты навсегда, хотя библиотека
    // в итоге была. Поэтому ждём её, а сдаёмся только по потолку.
    if (!map) {
        var t0 = Date.now();
        var iv = setInterval(function () {
            if (window.L) { clearInterval(iv); initMap(); if (map) { redraw(); } else { mapUnavailable(); } }
            else if (Date.now() - t0 > 15000) { clearInterval(iv); mapUnavailable(); }
        }, 150);
    }
    setInterval(load, 900000); // refresh every 15 min (FIRMS updates a few times/day)
    ae('tool_complete', { slug: 'wildfire-map' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
